import { render, staticRenderFns } from "./ComplaintView.vue?vue&type=template&id=d478e8ce&"
import script from "./ComplaintView.vue?vue&type=script&lang=js&"
export * from "./ComplaintView.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports